import axios from '../axios/axios';
import {
  PD_DATA_REQUEST,
  PD_DATA_SUCCESS,
  PD_DATA_FAIL,
} from '../constants/policyDetailsConstants';

export const policyDetailsAction = () => async (dispatch) => {
  try {
    dispatch({ type: PD_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s2',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: PD_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: PD_DATA_FAIL,
      payload: error,
    });
  }
};
